import React, { useContext } from 'react';
import { COM_1252_TEST_TOP_SERVICES_ADJUSTMENT_NAME } from '../constants';
import { useInTest } from '../../../../hooks';
import { Box } from '../../../../../../packages/ui';
import { HighlightedServicesStackContext } from '../HighlightedServicesSwiper/HighlightedServicesStackProvider';
import TopServiceRatingBannerABTestCOM1252 from '../HighlightedServicesSwiper/TopServiceRatingBannerABTestCOM1252';
import TopServiceHighlightedBannerABTestCOM1252 from '../HighlightedServicesSwiper/TopServiceHighlightedBannerABTestCOM1252';

export const TopServiceTagHandlerABTestCOM1252 = ({ service }) => {
  const isInTopServicesAdjustmentTest = useInTest(
    COM_1252_TEST_TOP_SERVICES_ADJUSTMENT_NAME,
  );
  const {
    popularServiceRankingMap,
    highlightedService,
  } = useContext(HighlightedServicesStackContext);

  if (!isInTopServicesAdjustmentTest) {
    return null;
  }

  if (popularServiceRankingMap[service.id] && !service?.isHighlight) {
    return (
      <Box style={{
        marginBottom: 5,
        marginTop: 5,
        alignItems: 'baseline',
      }}
      >
        <TopServiceRatingBannerABTestCOM1252
          serviceID={service.id}
          serviceRanking={popularServiceRankingMap[service.id]}
        />
      </Box>
    );
  }

  if (service?.isHighlight && service.id === highlightedService?.id) {
    return (
      <Box style={{
        marginBottom: 5,
        marginTop: 5,
        alignItems: 'baseline',
      }}
      >
        <TopServiceHighlightedBannerABTestCOM1252
          serviceID={service.id}
        />
      </Box>
    );
  }

  return null;
};
